package modysy.simulation.collision

import modysy.datastructures.Vector2
import modysy.model.GameObject

/** Provides collision checking. Before collisions are calculated, the game objects must be
  * registered.
  * */
abstract class CollisionEngine {

  /** Clear previously stored objects and register new objects. This must be called with the
    * actual objects before calculateCollisions methods are called.
    *
    * @param objects Objects to register.
    */
  def register(objects: Seq[GameObject]): Unit

  /** Find collisions between registered objects.
    *
    * @return Sequence of collision pairs between registered objects.
    *         If CollisionPair(obj1, obj2, ...) is present in the sequence,
    *         CollisionPair(obj2, obj1, ...) is guaranteed to be absent.
    */
  def calculateCollisions(): Seq[CollisionPair]

  /** Find collisions between a target object and registered objects.
    *
    * @return Sequence of collision pairs. First object in a pair is always targetObject, and
    *         second is always an object from registered objects. */
  def calculateCollisions(targetObject: GameObject): Seq[CollisionPair]

  /** Return registered objects such that point lies inside of them. */
  def findOnPoint(point: Vector2): Seq[GameObject]
}



// WEBPACK FOOTER //
// /home/gitlab-runner/builds/2d4fb5cd/0/mtv-pr-2018/modysy-product/src/main/scala/modysy/simulation/collision/CollisionEngine.scala